/**
 * Copyright 2021 Opstrace, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import useSWR from "swr";
import axios from "axios";

import { grafanaUrl } from "client/utils/grafana";

export const useLoki = (path: string, tenantName: string = "system") => {
  const url = `${grafanaUrl({
    tenant: tenantName
  })}/grafana/api/datasources/proxy/2/loki/api/v1/${path}`;

  return useSWR(url, fetcher);
};

export const usePrometheus = (path: string, tenantName: string = "system") => {
  const url = `${grafanaUrl({
    tenant: tenantName
  })}/grafana/api/datasources/proxy/1/api/v1/${path}`;

  return useSWR(url, fetcher);
};

const fetcher = (url: string) =>
  axios({
    method: "get",
    url: url,
    withCredentials: true
  }).then(res => res.data);
